import { apiQuestions } from '@/lib';
import { useQuery } from 'react-query';

interface useGetPatientQuestionResponsesProps {
  patientId: string;
  publicacaoId: string;
}

const useGetUsuarioDisparosQuiz = ({
  patientId,
  publicacaoId,
}: useGetPatientQuestionResponsesProps) => {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['patient-quizz-disparos', patientId],
    queryFn: async () => {
      const res = await apiQuestions.get(
        `publicacao/resultado-by-user/${patientId}`,
        {},
      );

      const results = res.data.filter(
        (r: { publicacaoId: string }) => r.publicacaoId === publicacaoId,
      );

      const resultsComRespostas = await Promise.all(
        results.map(async (item: any) => {
          const { data: respostas } = await apiQuestions.get(
            `publicacao/resposta-by-disparo/${item.disparoId}`,
            {},
          );
          return {
            ...item,
            respostas,
          };
        }),
      );

      return resultsComRespostas;
    },
  });

  return {
    data,
    isLoading,
    isError,
    refetch,
  };
};

export default useGetUsuarioDisparosQuiz;
